// extracted by mini-css-extract-plugin
export default {"container":"style_container__7-PLq","hidden":"style_hidden__Lieju","message":"style_message__enu-Y"};